module.exports = __webpack_public_path__ + "img/edge.3695d715.png";